import { createFileRoute } from '@tanstack/react-router';
import { JourneysPersonActivityRoute } from './-route-wrappers';

/**
 * `/journeys/people/:personId/activity` — the address the embedded app's profile tab bar links
 * to. It forwards to the tab's own URL once the rollout flag is on, and renders the embedded app
 * in place while it is off.
 */
function JourneysPersonActivityIndexRoute() {
  const { personId } = Route.useParams();

  return <JourneysPersonActivityRoute personId={personId} />;
}

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/journeys/people/$personId/activity/')({
  component: JourneysPersonActivityIndexRoute,
});
